<img
  [src]="'assets/img/' + icon().icon"
  [alt]="icon().icon"
  [style.filter]="icon().color && colorService.getFilter(icon().color)"
/>
